import Paper from '@mui/material/Paper';
import React from 'react';
import { connect } from 'react-redux';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import {
  createRelayControllerFirmwareVersion,
  patchRelayControllerFirmwareVersion,
  rawFetchAllRelayControllerFirmwareVersions,
} from '@sophocles/entities/RelayControllerFirmwareVersion';
import { getAuthUserSelector } from '@sophocles/features/auth/authSelectors';
import { loadReference, selectUnitModels } from '@sophocles/features/reference';
import FirmwareMatrixTable from '@sophocles/views/admin/engineering/firmwareMatrix/FirmwareMatrixTable';

class FirmwareMatrixPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  componentDidMount() {
    // The Models column names each id from the reference catalog; the thunk
    // no-ops once it has loaded this session.
    this.props.loadReference();
  }

  _setLoading = loading => this.setState({ loading });

  render() {
    const { customer } = this.props;
    const { loading } = this.state;

    const pageTitle = 'Firmware Matrix';

    return (
      <AppNav {...this.props} loading={loading} page="admin_home" notFullHeight={true}>
        <div className="container-fluid" style={{ top: '64px', margin: '0 var(--page-px)' }}>
          <TitleBar title={pageTitle} showBackButton />
          <div className="row" style={{ height: 'calc(100% - 64px)' }}>
            {/* Left Filter Section */}
            {/* Right Section */}
            <Paper
              style={{
                width: '100%',
                height: '100%',
                backgroundColor: 'var(--surface-primary)',
                marginBottom: 'var(--space-4)',
              }}
            >
              <FirmwareMatrixTable {...this.props} setLoading={this._setLoading} />
            </Paper>
          </div>
        </div>
      </AppNav>
    );
  }
}

function mapStateToProps(state) {
  return { user: getAuthUserSelector(state), unitModels: selectUnitModels(state) };
}

function mapDispatchToProps(dispatch) {
  return {
    loadReference: () => dispatch(loadReference()),
    fetchData: () => dispatch(rawFetchAllRelayControllerFirmwareVersions()),
    patchRelayControllerFirmwareVersion: (version_id, values) =>
      dispatch(patchRelayControllerFirmwareVersion(version_id, values)),
    createRelayControllerFirmwareVersion: values => dispatch(createRelayControllerFirmwareVersion(values)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FirmwareMatrixPage);
